import { DialogProps } from '@material-ui/core';
import React from 'react';
import { suppliersCommand_patchName, ISupplier } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import { StringModelForm } from 'framework/forms/StringModelForm';

interface IProps extends DialogProps {
	supplier: ISupplier;
	confirm: VoidFunction;
	cancel: VoidFunction;
}

export const SupplierNameForm = ({ supplier, ...rest }: IProps) => {
	const strings = useLocalization();

	return (
		<StringModelForm
			fullWidth
			label={strings.name}
			formTitle={strings.changeWhat(strings.supplierName)}
			notifyMessage={strings.supplierUpdated}
			submitFunction={val => suppliersCommand_patchName({ supplierId: supplier.id, name: val })}
			initialValue={supplier.name ?? ''}
			submitText={strings.update}
			{...rest}
		/>
	);
};
